import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequestHandler } from "./service";
// This will generate an asyncThunk that only calls the API
export const createApiThunk = (typePrefix, configFn) =>
  createAsyncThunk(typePrefix, async (payload, thunkAPI) => {
    try {
      const config = configFn(payload, thunkAPI); // Return { method, endPoint, data, etc. }
      const response = await apiRequestHandler(config);

      if (response.success || response.status === 200 ||response.status === 300 || response.responseCode === 300 || response.responseCode === 200 || response.responseCode === 201|| response.status === 201 ) {
        return response;
      } else {
        return thunkAPI.rejectWithValue(response.message || "API error");
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Unknown error");
    }
  });
